enum Links {
  LinkedIn = 'https://www.linkedin.com/company/lacadordigital/',
  LinkedInJobs = 'https://www.linkedin.com/company/lacadordigital/jobs/',
}

export default Links;